import styled, { css } from 'styled-components';
import { FlexAlignCenter, FlexCol } from 'components/primitives/flex';

export default function TripAssurance({ isModal = false }) {
  return (
    <TripAssuranceWrapper gap="15px" isModal={isModal}>
      <ShieldCheck />
      <FlexCol>
        <TripAssuranceHeader>Trip assurance available</TripAssuranceHeader>
        <TripAssuranceSubtext>Cancel anytime before your trip for a full refund</TripAssuranceSubtext>
      </FlexCol>
    </TripAssuranceWrapper>
  );
}

const TripAssuranceHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
`;
const TripAssuranceSubtext = styled.div`
  font-size: 12px;
  color: #434c5c;
`;

const TripAssuranceWrapper = styled(FlexAlignCenter)<{ isModal: boolean }>`
  margin-top: 24px;
  margin-bottom: 24px;

  ${({ isModal }) =>
    isModal &&
    css`
      margin-top: 0;
    `}
`;

const ShieldCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0A4195"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
